var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShowMoreArrow = function SvgShowMoreArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 8.652 15.436"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.4,
    d: "M.446 15.023a.729.729 0 0 1-.07-.945l.07-.081 6.228-6.261L.446 1.475A.729.729 0 0 1 .376.53l.07-.081a.719.719 0 0 1 .94-.07l.081.07 6.738 6.774a.729.729 0 0 1 .07.945l-.07.081-6.738 6.774a.719.719 0 0 1-1.021 0Z",
    "data-name": "Path 370"
  })));
};
export default SvgShowMoreArrow;